//text-3xs = 8px text-2xs = 10px text-xs = 12px, text-sm = 14px, text-base = 16px, text-lg = 18px, text-xl = 20px, text-2xl = 22px, text-3xl = 24px, text-4xl = 28px, text-5xl = 32px, text-6xl = 36px, text-7xl = 40px, text-8xl = 44px, text-9xl = 48px, text-10xl = 56px
const fontSizes = {
  "3xs": "8px",
  "2xs": "10px",
  xs: "12px",
  sm: "14px",
  base: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "22px",
  "3xl": "24px",
  "4xl": "28px",
  "5xl": "32px",
  "6xl": "36px",
  "7xl": "40px",
  "8xl": "44px",
  "9xl": "48px",
  "10xl": "56px",
};

const fontHeading = [
  { fontSize: fontSizes, color: "#000000" },
  { fontSize: fontSizes, color: "#F56565" },
  { fontSize: fontSizes, color: "#000000" },
  { fontSize: fontSizes, color: "rgba(0, 0, 0, 0.5)" },
  { fontSize: fontSizes, color: "#000000" },
  { fontSize: fontSizes, color: "#F56565" },
  { fontSize: fontSizes, color: "#000000" },
  { fontSize: fontSizes, color: "#000000" },
  { fontSize: fontSizes, color: "#FFFFFF" },
  { fontSize: fontSizes, color: "#F56565" },
  { fontSize: fontSizes, color: "#FFFFFF" },
  { fontSize: fontSizes, color: "#FFFFFF" },
];

const fontBody = [
  { fontSize: fontSizes, fontWeight: "500", color: "#FFFFFF" },
  { fontSize: fontSizes, fontWeight: "500", color: "rgba(0, 0, 0, 0.5)" },
  { fontSize: fontSizes, fontWeight: "500", color: "#000000" },
  { fontSize: fontSizes, fontWeight: "500", color: "#F56565" },
];

const fontLabel = [
  { size: "14px", fontWeight: "500", color: "#F56565" },
  { size: "14px", fontWeight: "500", color: "rgba(0, 0, 0, 0.5)" },
  { size: "12px", fontWeight: "500", color: "rgba(0, 0, 0, 0.5)" },
  { size: "20px", fontWeight: "600", color: "#F56565" },
  { size: "20px", fontWeight: "600", color: "#4299E1" },
  { size: "20px", fontWeight: "600", color: "#48BB78" },
  { size: "20px", fontWeight: "600", color: "#ECC94B" },
];

const textStyles = {
  // --------------------------------------------------Heading-----------------------------------------------
  // Primary Color
  "h-5xl-primary": {
    // 32/34
    fontSize: fontHeading[0].fontSize?.["5xl"],
    fontWeight: "600",
    color: fontHeading[0].color,
  },
  "h-3xl-primary": {
    //24
    fontSize: fontHeading[2].fontSize?.["3xl"],
    fontWeight: "600",
    color: fontHeading[2].color,
  },
  "h-xl-primary": {
    //20
    fontSize: fontHeading[4].fontSize?.xl,
    fontWeight: "600",
    color: fontHeading[4].color,
  },
  "h-lg-primary": {
    // 18
    fontSize: fontHeading[11].fontSize?.lg,
    fontWeight: "600",
    color: fontHeading[4].color,
  },
  "h-base-primary": {
    //16
    fontSize: fontHeading[6].fontSize?.base,
    fontWeight: "600",
    color: fontHeading[6].color,
  },
  "h-sm-primary": {
    //14
    fontSize: fontHeading[7].fontSize?.sm,
    fontWeight: "600",
    color: fontHeading[7].color,
  },
  "h-xs-primary": {
    //12
    fontSize: fontHeading[7].fontSize?.xs,
    fontWeight: "600",
    color: fontHeading[7].color,
  },
  "h-2xs-primary": {
    //10
    fontSize: fontHeading[7].fontSize?.["2xs"],
    fontWeight: "600",
    color: fontHeading[7].color,
  },
  // Secondary Color
  "h-5xl-secondary": {
    //34/32
    fontSize: fontHeading[1].fontSize?.["5xl"],
    fontWeight: "600",
    color: fontHeading[1].color,
  },
  "h-3xl-secondary": {
    //24
    fontSize: fontHeading[5].fontSize?.["3xl"],
    fontWeight: "600",
    color: fontHeading[5].color,
  },
  "h-xl-secondary": {
    //20
    fontSize: fontHeading[5].fontSize?.xl,
    fontWeight: "600",
    color: fontHeading[5].color,
  },
  "h-base-secondary": {
    //16
    fontSize: fontHeading[5].fontSize?.base,
    fontWeight: "600",
    color: fontHeading[5].color,
  },
  "h-sm-secondary": {
    //14
    fontSize: fontHeading[9].fontSize?.sm,
    fontWeight: "600",
    color: fontHeading[9].color,
  },
  "h-xs-secondary": {
    //12
    fontSize: fontHeading[9].fontSize?.xs,
    fontWeight: "600",
    color: fontHeading[9].color,
  },
  // White Color
  "h-7xl-white": {
    //40
    fontSize: fontHeading[11].fontSize?.["7xl"],
    fontWeight: "600",
    color: fontHeading[11].color,
  },
  "h-3xl-white": {
    //24
    fontSize: fontHeading[11].fontSize?.["3xl"],
    fontWeight: "600",
    color: fontHeading[11].color,
  },
  "h-xl-white": {
    //20
    fontSize: fontHeading[11].fontSize?.xl,
    fontWeight: "600",
    color: fontHeading[11].color,
  },
  "h-lg-white": {
    //20
    fontSize: fontHeading[11].fontSize?.lg,
    fontWeight: "600",
    color: fontHeading[11].color,
  },
  "h-base-white": {
    //16
    fontSize: fontHeading[11].fontSize?.base,
    fontWeight: "600",
    color: fontHeading[11].color,
  },
  "h-sm-white": {
    //14
    fontSize: fontHeading[8].fontSize?.sm,
    fontWeight: "600",
    color: fontHeading[8].color,
  },
  "h-xs-white": {
    //12
    fontSize: fontHeading[10].fontSize?.xs,
    fontWeight: "600",
    color: fontHeading[11].color,
  },
  // Gray50 Color
  "h-3xl-gray50": {
    //24
    fontSize: fontHeading[3].fontSize?.["3xl"],
    fontWeight: "600",
    color: fontHeading[3].color,
  },
  "h-sm-gray50": {
    //14
    fontSize: fontHeading[3].fontSize?.sm,
    fontWeight: "600",
    color: fontHeading[3].color,
  },
  "h-xs-gray50": {
    //12
    fontSize: fontHeading[3].fontSize?.xs,
    fontWeight: "600",
    color: fontHeading[3].color,
  },
  "h-2xs-gray50": {
    //10
    fontSize: fontHeading[3].fontSize?.["2xs"],
    fontWeight: "600",
    color: fontHeading[3].color,
  },
  "h-title": {
    fontSize: [16, null, 18],
    fontWeight: "600",
  },
  "h-reg-title": {
    fontSize: [14, null, 16],
    fontWeight: "600",
  },
  "h-subtitle": {
    fontSize: [12, null, 14],
    fontWeight: "normal",
  },

  // --------------------------------------------------Body------------------------------------------------
  // primary color
  "b-xs-primary": {
    //12
    fontSize: fontBody[2].fontSize?.xs,
    fontWeight: 500,
    color: fontBody[2].color,
  },
  "b-sm-primary": {
    //14
    fontSize: fontBody[2].fontSize?.sm,
    fontWeight: 500,
    color: fontBody[2].color,
  },
  "b-2xs-primary": {
    //10
    fontSize: fontBody[2].fontSize?.["2xs"],
    fontWeight: 500,
    color: fontBody[2].color,
  },
  "b-3xs-primary": {
    //8
    fontSize: fontBody[3].fontSize?.["3xs"],
    fontWeight: 500,
    color: fontBody[2].color,
  },
  // white color
  "b-5xl-white": {
    //34/32
    fontSize: fontBody[0].fontSize?.["5xl"],
    fontWeight: 500,
    color: fontBody[0].color,
  },
  "b-xl-white": {
    //20
    fontSize: fontBody[0].fontSize?.xl,
    fontWeight: 500,
    color: fontBody[0].color,
  },
  "b-lg-white": {
    //20
    fontSize: fontBody[0].fontSize?.lg,
    fontWeight: 500,
    color: fontBody[0].color,
  },
  "b-sm-white": {
    //14
    fontSize: fontBody[0].fontSize?.sm,
    fontWeight: 500,
    color: fontBody[0].color,
  },
  "b-xs-white": {
    //12
    fontSize: fontBody[2].fontSize?.xs,
    fontWeight: 500,
    color: fontBody[0].color,
  },
  // Gray50 Color
  "b-base-gray50": {
    //16
    fontSize: fontBody[1].fontSize?.base,
    fontWeight: 500,
    color: fontBody[1].color,
  },
  "b-sm-gray50": {
    //14
    fontSize: fontBody[2].fontSize?.sm,
    fontWeight: 500,
    color: fontBody[1].color,
  },
  "b-xs-gray50": {
    //12
    fontSize: fontBody[2].fontSize?.xs,
    fontWeight: 500,
    color: fontBody[1].color,
  },
  "b-2xs-gray50": {
    //10
    fontSize: fontBody[2].fontSize?.["2xs"],
    fontWeight: 500,
    color: fontBody[1].color,
  },
  "b-sm-secondary": {
    //14
    fontSize: fontBody[2].fontSize?.sm,
    fontWeight: 500,
    color: fontBody[3].color,
  },
  "b-xs-secondary": {
    //12
    fontSize: fontBody[2].fontSize?.xs,
    fontWeight: 500,
    color: fontBody[3].color,
  },
  "b-reg": {
    fontSize: [12, null, 14],
    fontWeight: "normal",
  },
  "b-reg-sb": {
    fontSize: [12, null, 14],
    fontWeight: "600",
  },
  "b-sm-sb": {
    fontSize: [10, null, 12],
    fontWeight: "semibold",
  },
  "b-sm": {
    fontSize: [10, null, 12],
    fontWeight: "normal",
  },

  // --------------------------------------------------Label------------------------------------------------
  "label-secondary": {
    fontSize: fontLabel[0].size,
    fontWeight: fontLabel[0].fontWeight,
    color: fontLabel[0].color,
  },
  "label-sm-gray50": {
    //14
    fontSize: fontLabel[1].size,
    fontWeight: fontLabel[1].fontWeight,
    color: fontLabel[1].color,
  },
  "label-2xs-gray50": {
    //10
    fontSize: fontLabel[2].size,
    fontWeight: fontLabel[2].fontWeight,
    color: fontLabel[2].color,
  },
  "label-alert": {
    fontSize: fontLabel[3].size,
    fontWeight: fontLabel[3].fontWeight,
    color: fontLabel[3].color,
  },
  "label-info": {
    fontSize: fontLabel[4].size,
    fontWeight: fontLabel[4].fontWeight,
    color: fontLabel[4].color,
  },
  "label-success": {
    fontSize: fontLabel[5].size,
    fontWeight: fontLabel[5].fontWeight,
    color: fontLabel[5].color,
  },
  "label-warning": {
    fontSize: fontLabel[6].size,
    fontWeight: fontLabel[6].fontWeight,
    color: fontLabel[6].color,
  },
};

export default textStyles;
